<div #dialog class='Dialog'>
  <h2
    cdkDrag
    cdkDragHandle
    cdkDragRootElement='.cdk-overlay-pane'
    mat-dialog-title>
    <mat-toolbar class='Dialog-toolbar task-header' role='toolbar'>
      &nbsp;<app-svg-renderer
      (click)='openTooltip(data.componentData.data?.tag)'
      *ngIf='showTitleTooltip || data.titleIcon'
      [svg]='getTitleIcon()'></app-svg-renderer>
      <span class='dialog-title'> {{ data.title }}</span>
      <span class='fx-spacer' style='flex: 1 1 auto'></span>
      <button
        (click)='close()'
        *ngIf='data.canClose === true'
        class='Dialog--close-button'
        mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </h2>

  <div #dialogContainer class='Dialog-container'>
    <mat-dialog-content>
      <p *ngIf='contentAsHtml === true' [innerHtml]='data.content'>
        {{ data.content }}
      </p>
      <ng-template #content></ng-template>
    </mat-dialog-content>
  </div>

  <div
    *ngIf='data.buttons && data.buttons.length > 0 || data.canClose'
    class='Dialog-actions'
    mat-dialog-actions>

    <div *ngIf='data.buttons && data.buttons.length || data.canClose' class='flex-grow-0'>
      <app-button
        (click)='onCloseButton()'
        *ngIf='data.canClose'
        [text]='data.closeButtonText'
        class='ml-2'
        color='dark'
        size='normal'></app-button>
      <app-svg-renderer (click)='openTooltip(data.tips)'
                        *ngIf='data.tips'
                        [svg]="'Yellow Plane'"></app-svg-renderer>
    </div>
    <div
      *ngIf='data.buttons && data.buttons.length'
      class='Dialog-actions-item flex-grow-1'>
      <ng-container *ngFor='let button of data.buttons'>
        <app-button
          #dialogButtons
          [Click]='onButtonClick.bind(this, button)'
          [class.hidden]='componentNotReady()'
          [color]="
          button.color === 'red' || button.color === 'orange'
            ? button.color
            : 'blue'
        "
          [disabled]='button.disabled'
          [id]='button.id'
          [observeApi]='true'
          [route]='button.route'
          [style]="'dialog-filled'"
          [text]='button.text'
          class='ml-2'
          size='normal'></app-button>
      </ng-container>
    </div>
  </div>
</div>
